<ng-container *ngFor="let question of block.questions">
  <ng-container *ngFor="let content of question.contents">
    <div class="vertical-container">
      <ng-container [ngSwitch]="content?.block?.blockType">
        <ng-container *ngSwitchCase="blockTypeEnum.WYSIWYGBlock">
          <app-wysiwyg-viewer [wysiwyg]="content.block"></app-wysiwyg-viewer>
        </ng-container>
        <ng-container *ngSwitchCase="blockTypeEnum.VideoEmbedBlock">
          <app-video-embed-viewer
            [videoEmbed]="content.block"
          ></app-video-embed-viewer>
        </ng-container>
        <ng-container *ngSwitchCase="blockTypeEnum.KaraokeBlock">
          <app-karaoke-player [block]="content.block"></app-karaoke-player>
        </ng-container>
        <ng-container *ngSwitchCase="blockTypeEnum.ImageBlock">
          <app-view-image-block
            [imageBlock]="content.block"
          ></app-view-image-block>
        </ng-container>
        <ng-container *ngSwitchCase="blockTypeEnum.QuizBlock">
          <app-shared-quiz-block-viewer
            [block]="content.block"
          ></app-shared-quiz-block-viewer>
        </ng-container>
      </ng-container>
    </div>
  </ng-container>
</ng-container>
